var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "row mx-auto col-12" },
      [
        _c("icon-view", {
          staticClass: "mt-md-0 mt-sm-5 icon-font-22",
          attrs: {
            gradient: "",
            icon: "fas fa-user-tie mb-1",
            "icon-color": "#ff7058",
            "icon-size": "20px",
            title: "Detalle Muestra"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "button-header d-flex justify-content-end" },
      [
        _c(
          "action-button",
          {
            attrs: {
              i: "fas fa-arrow-circle-left",
              responsive: false,
              variant: "outline-success m-1"
            },
            on: { click: _vm.goBack }
          },
          [_vm._v(" Regresar ")]
        ),
        _vm.hasUnconfirmedSamplePrevisualizationData &&
        _vm.isValidArea &&
        !_vm.isConfirming
          ? _c(
              "action-button",
              {
                attrs: {
                  i: "fas fa-times-circle",
                  responsive: false,
                  variant: "outline-danger m-1"
                },
                on: { click: _vm.declineSample }
              },
              [_vm._v(" Rechazar ")]
            )
          : _vm._e(),
        _vm.hasUnconfirmedSamplePrevisualizationData &&
        _vm.isValidArea &&
        !_vm.isConfirming
          ? _c(
              "action-button",
              {
                attrs: {
                  i: "fas fa-check",
                  responsive: false,
                  variant: "success m-1"
                },
                on: { click: _vm.confirmSample }
              },
              [_vm._v(" Confirmar ")]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._m(0),
    _c("div", { staticClass: "questionnaire-collapse mx-auto" }, [
      _c(
        "div",
        { staticClass: "row mx-auto col-12" },
        [
          _c("icon-view", {
            staticClass: "mt-md-0 mt-sm-5",
            attrs: {
              gradient: "",
              icon: "fas fa-clipboard-list-check d-flex mb-1",
              "icon-background": "#ff7058",
              "icon-color": "#fff",
              "icon-size": "14px",
              title: `Tabla de Cuestionario ${_vm.academicYearName || ""}`
            }
          })
        ],
        1
      ),
      _vm.isEvaluationTherapiesArea
        ? _c("div", { staticClass: "evaluation-therapies-wrapper" }, [
            _c(
              "div",
              { staticClass: "family-evaluation-sample col-12 my-3 mt-4" },
              [
                _c("questionnaire-collapse", {
                  key: `family-evaluation-sample-${_vm.keyIndex}`,
                  attrs: {
                    "sample-type": _vm.sampleTypes.FamilyEvaluation,
                    title: "Familia - Evaluación"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "family-therapy-sample col-12 my-3" },
              [
                _c("questionnaire-collapse", {
                  key: `family-therapy-sample-${_vm.keyIndex}`,
                  attrs: {
                    "sample-type": _vm.sampleTypes.FamilyTherapy,
                    title: "Familia - Terapias"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "teacher-sample col-12 my-3" },
              [
                _c("questionnaire-collapse", {
                  key: `teacher-sample-${_vm.keyIndex}`,
                  attrs: {
                    "is-teacher": "",
                    "sample-type": _vm.sampleTypes.FamilyTherapy,
                    title: "Maestros"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.isTransportationArea
        ? _c("div", { staticClass: "transportation-wrapper" }, [
            _c(
              "div",
              { staticClass: "transportation-general-sample col-12 my-3" },
              [
                _c("questionnaire-collapse", {
                  key: `transportation-general-${_vm.keyIndex}`,
                  attrs: {
                    "academic-year-id": _vm.academicYearId,
                    "area-id": _vm.transportationAreaId,
                    "period-number": _vm.periodNumber,
                    "sample-type": null,
                    title: "Familia - Transportación"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 mx-auto my-2" }, [
      _c("div", { staticClass: "dropdown-divider" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }